import React from 'react';
import { AddCustomerIcon, DeleteIcon, EditIcon } from '@routific/hive/v5';
import type { V5MenuAction } from '@routific/hive/v5';
import { TFunction } from 'i18next';

interface MenuItemsProps {
  t: TFunction;
  disabled: boolean;
  createCustomerDisabled: boolean;
  isReattemptStop: boolean;
  permissions: {
    allowEdit: boolean;
    allowDelete: boolean;
  };
  handlers: {
    onEdit: () => void;
    onDelete: () => void;
    onCreateCustomer: () => void;
  };
  tooltips: {
    edit?: string;
    delete?: string;
    createCustomer?: string;
  };
}

const getOrderActionsMenuItems = ({
  t,
  disabled,
  createCustomerDisabled,
  isReattemptStop,
  permissions,
  handlers,
  tooltips,
}: MenuItemsProps): V5MenuAction[] => {
  const { allowEdit, allowDelete } = permissions;
  const { onEdit, onDelete, onCreateCustomer } = handlers;

  return [
    {
      id: 'edit',
      label: <span data-testid="edit-btn">{t('visitInfoCard.edit.footerButton')}</span>,
      icon: <EditIcon size="md" />,
      disabled: disabled || !allowEdit,
      tooltip: tooltips.edit,
      onSelect: onEdit,
    },
    {
      id: 'createCustomer',
      label: <span data-testid="createCustomer-btn">{t('visitInfoCard.createCustomer.text')}</span>,
      icon: <AddCustomerIcon size="md" />,
      disabled: createCustomerDisabled,
      tooltip: tooltips.createCustomer,
      onSelect: onCreateCustomer,
    },
    {
      id: 'delete',
      label: <span data-testid="delete-btn">{t('visitInfoCard.delete.footerButton')}</span>,
      icon: <DeleteIcon size="md" />,
      disabled: disabled || !allowDelete || isReattemptStop,
      destructive: true,
      tooltip: tooltips.delete,
      onSelect: onDelete,
    },
  ];
};

export default getOrderActionsMenuItems;
